<template>
  <div id="hero-banner">
    <div class="hero-content">
      <div class="container">
        <h1 class="title"><span>Arkayl</span>Solutions</h1>
        <p class="description">{{ $t('heroContent') }}</p>
        <router-link class="primary-button" to="/contact">{{ $t('scheduleCall') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hero-section'
}
</script>

<style scoped>
  .hero-content {
    background: linear-gradient(0deg, rgb(4 16 24) 0%, rgb(30 180 203 / 46%) 38%, rgba(237, 221, 83, 0) 100%), url('@/assets/images/homepage/hero.jpg'),#2c3e50;
    background-position: center;
    background-size: cover;
    height: 730px;
    width: 100%;
    border-radius: 0 0 40px 40px;
    overflow: hidden;
  }

  .hero-content .container {
    height: 100%;
    align-content: center;
    text-align: left;
    color: #fff;
  }

  .hero-content .container .description {
    margin-block: 24px;
  }

  .hero-content .container h1 {
    color: #fff;
  }
  @media(max-width: 1000px) {
    .hero-content .container h1 {
      font-size: 3.5rem;
    }
    .hero-content {
      height: 630px;
    }
  }
</style>
